import { type Option } from "src/base-components/Select";
import { CaseStatusPill } from "src/cases/common/CaseStatusPill";
import { CasePropertiesValue } from "src/clients/case-management";
import { PillVariants } from "src/design-system/Pill";

export const STATUS_KEY_SEPARATOR = "#";

export const getStatusOptions = (
  property: CasePropertiesValue | undefined,
): Option[] => {
  if (!property || property.type !== "enum") return [];

  const options: Option[] = [];

  property.values.forEach((value) => {
    if (value.sub_values && value.sub_values.length > 0) {
      value.sub_values.forEach((subValue) => {
        options.push({
          value: (
            <CaseStatusPill
              status={value.value}
              subStatus={subValue.value}
              variant={value.color as PillVariants}
            />
          ),
          key: `${value.value}${STATUS_KEY_SEPARATOR}${subValue.value}`,
        });
      });
    } else {
      options.push({
        value: (
          <CaseStatusPill
            status={value.value}
            variant={value.color as PillVariants}
          />
        ),
        key: value.value,
      });
    }
  });

  return options;
};

export const parseStatusKey = (
  key: string,
): { status: string; subStatus?: string } => {
  const parts = key.split(STATUS_KEY_SEPARATOR);
  return { status: parts[0], subStatus: parts[1] };
};
